<template>
    <ActionDropdown :actions="actions" cssClass="ms-1" />
    <PermissionModal :application="application" ref="PermissionModal" @created="$emit('created', $event)" />
    <PermissionImportModal ref="PermissionImportModal" @updated="$emit('updated', $event)" :application="application" />
    <ImportModal ref="ImportModal" @created="$emit('created', $event)"
        :endpoint="`applications/${this.application.id}/permissions/import-excel`" :name="i18n('Permissions')" :columns="[
      'code',
      'name',      
    ]">
    </ImportModal>
</template>

<script>
import api from "@/api.js";
import ActionDropdown from "@/components/common/list/ActionDropdown.vue";
import PermissionModal from "@/components/permission/PermissionModal.vue";
import PermissionImportModal from "@/components/permission/PermissionImportModal.vue";
import ImportModal from "@/components/common/import/ImportModal.vue";

export default {
    components: {
        ActionDropdown,
        PermissionModal,
        PermissionImportModal,
        ImportModal,
    },
    props: {
        application: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            permissions: [],
            filters: {},
            loadTimeout: null,
            loading: true,
        };
    },
    emits: [
        'updated',
        'created',
        'shown',
        'hidden',
        'submit',
    ],
    methods: {
        showPermissionModal() {
            if (!this.$refs['PermissionModal']) return;
            this.$refs['PermissionModal'].show();
        },
        showPermissionImportModal() {
            if (!this.$refs['PermissionImportModal']) return;
            this.$refs['PermissionImportModal'].show();
        },
    },
    computed: {
        actions() {
            return [
                {
                    label: this.i18n('Add New'),
                    fn: () => {
                        this.showPermissionModal();
                    },
                    if: this.application?.acl?.update === true,
                    starred: true,
                },
                {
                    label: this.application.authorizationType?.code !== 'profiles' ? this.i18n('Export permissions Json') : this.i18n('Export profiles Json'),
                    fn: () => {
                        api.getFile(`applications/${this.application.id}/permissions/export`, {}, 'export_permissions_' + this.application.name + '.json').then(result => {
                            api.clearCache();
                        }).catch((err) => {
                            this.$root.showErrorModal(this.i18n('Error'), this.i18n('Document could not be downloaded. Try again later.'));
                        });
                    },
                    if: this.application?.acl?.export === true,
                },
                {
                    label: this.application.authorizationType?.code !== 'profiles' ? this.i18n('Export permissions Excel') : this.i18n('Export profiles Excel'),
                    fn: () => {
                        api.getFile(`applications/${this.application.id}/permissions/export-excel`, {}, 'export_permissions_' + this.application.name + '.xlsx').then(result => {
                            api.clearCache();
                        }).catch((err) => {
                            this.$root.showErrorModal(this.i18n('Error'), this.i18n('Document could not be downloaded. Try again later.'));
                        });
                    },
                    if: this.application?.acl?.export === true && this.$root?.features?.permissions?.import_export_excel,
                },
                {
                    label: this.application.authorizationType?.code !== 'profiles' ? this.i18n('Import Permissions Json') : this.i18n('Import Profiles Json'),
                    fn: () => {
                        this.showPermissionImportModal();
                    },
                    if: this.application?.acl?.import === true,
                },
                {
                    label: this.application.authorizationType?.code !== 'profiles' ? this.i18n('Import permissions Excel') : this.i18n('Import profiles Excel'),
                    fn: () => {
                        this.$refs['ImportModal'].show();
                    },
                    if: this.application?.acl?.import === true && this.$root?.features?.permissions?.import_export_excel,
                },
            ];
        },
    },
};
</script>